import React from 'react';
import { ToolbarButton } from '@marvelapp/ui';
import { HandoffIcon } from './icons';
export default function SidebarHandoff(_a) {
    var onClick = _a.onClick;
    return (React.createElement(ToolbarButton, { alignItems: "center", display: "flex", fill: "slate", fontFamily: 0, onClick: onClick },
        React.createElement(HandoffIcon, { display: "block", marginLeft: "-2px", marginRight: "10px" }),
        "Handoff"));
}
